import Request from './request';
import store from '@/store.js'
import i18n from '@/i18n'
import snackbar from '@/plugins/snackbar'

async function fetch(data) {// 获取优惠券一览
    return Request('get', "api/purchase-plans/index", data);
}

async function fetchOne(id, data) {// 获取单个
    return Request('get', "api/purchase-plans/view/" + id, data);
}

async function getPurchaseableDetails(data) {
    return Request('post', "api/purchase-plans/get-purchaseable-details", data);
}

async function addViews(data) {
    return Request('post', "api/purchase-plans/add-views", data);
}

async function add(data) {
    return Request('post', "api/purchase-plans/add", data);
}

async function edit(id, data) {
    // 获取相关单据
    return Request('post', 'api/purchase-plans/edit/' + id, data)
}

async function distribute(data) {
    return Request('post', "api/purchase-plans/distribute", data);
}

async function fetchRelations(id, data) {
    // 获取相关单据
    if (id != '') {
        return Request('get', 'api/purchase-plans/' + id + '/relations', data)
    }else {
        return Request('get', 'api/purchase-plans/relations', data)
    }
}

async function batchDetailExport(data) {
    // 采购计划单批量导出
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/purchase-plans/batch-detail-export', data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function detailExport(id) {
    // 采购计划单详情导出
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/purchase-plans/detail-export/' + id)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function cancel(id) {
    // 获取相关单据
    return Request('get', 'api/purchase-plans/cancel/' + id)
}

async function getAutoRuler() {
    // 获取自动策略
    return Request('get', 'api/purchase-plans/get-auto-ruler')
}

async function saveAutoRuler(data) {
    // 获取自动策略
    return Request('post', 'api/purchase-plans/save-auto-ruler', data)
}

export default {
    fetch,
    fetchOne,
    getPurchaseableDetails,
    addViews,
    add,
    distribute,
    fetchRelations,
    batchDetailExport,
    detailExport,
    cancel,
    edit,
    getAutoRuler,
    saveAutoRuler
};